<template>
  <div class="stack-select-section">
    <span v-for="(stack, index) in stacks" :key="stack.uuid">
      <el-dropdown @command="handleSelectStackLevelCommand">
        <el-tag
          :closable="!disabled"
          :disable-transitions="false"
          :effect="!stack.level && stack.level !== 0 ? 'plain' : 'light'"
          :type="transformTagType(stack)"
          @close="handleClose(stack)"
        >
          <!-- <img class="tag-icon" :src="stack.image_url" /> -->
          <span class="tag-text">{{ transformLevelText(stack) }}</span>
        </el-tag>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(val, key) in STACK_LEVEL_OPTIONS"
            :key="key"
            :command="`${index}-${key}`"
            :disabled="disabled"
          >
            {{ val }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </span>
    <el-select
      ref="saveTagInput"
      v-if="inputVisible"
      v-model="inputValue"
      multiple
      filterable
      remote
      reserve-keyword
      size="small"
      placeholder="请输入技能点"
      :loading="loading"
      :remote-method="remoteMethod"
      @visible-change="handleVisibleChange"
    >
      <el-option
        v-for="item in searchStacks"
        :key="item.id"
        :label="item.name"
        :disabled="stacksIds.includes(item.id)"
        :value="item.id"
      >
      </el-option>
    </el-select>
    <el-button
      v-else-if="!disabled"
      class="button-new-tag"
      size="medium"
      @click="handleShowInput"
      >+ 添加技能点
    </el-button>
  </div>
</template>

<script type="text/javascript">
const STACK_LEVEL_OPTIONS = {
  0: "不要求",
  1: "了解",
  2: "熟悉",
  3: "掌握",
  4: "精通",
  5: "专家"
};
import kcellService from "@/global/service/kcell";

export default {
  props: {
    stacks: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      STACK_LEVEL_OPTIONS,
      loading: false,
      inputVisible: false,
      inputValue: [],
      searchStacks: [],
      allSearchStacks: {}
    };
  },
  computed: {
    stacksIds() {
      return this.stacks.map(data => data.id);
    }
  },
  methods: {
    handleClose(datas) {
      const stack = { ...datas };
      const { name } = stack;
      this.$confirm(`确定移除「 ${name} 」技能点?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.stacks.splice(this.stacks.indexOf(datas), 1);
        })
        .catch(() => {});
    },
    remoteMethod(name) {
      this.loading = true;
      if (!name) return;
      kcellService
        .kcellSkills({ name })
        .then(res => {
          this.searchStacks = res;
          this.searchStacks.forEach(data => {
            this.allSearchStacks[data.id] = data;
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleVisibleChange(visible) {
      if (visible === false) {
        this.handleInputConfirm();
      } else {
        this.remoteMethod();
      }
    },
    handleInputConfirm() {
      const stacks = this.inputValue.map(item => this.allSearchStacks[item]);
      stacks.forEach(data => {
        const item = { ...data };
        this.stacks.push(item);
      });
      this.inputVisible = false;
      this.inputValue = [];
      this.searchStacks = [];
    },
    handleShowInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    transformLevelText(stack) {
      const { STACK_LEVEL_OPTIONS } = this;
      if (!stack.level && stack.level !== 0) {
        return `请选择「${stack.name}」技能水平`;
      } else {
        return `${stack.name} - ${STACK_LEVEL_OPTIONS[stack.level]}`;
      }
    },
    transformTagType(stack) {
      const level = stack.level || 0;
      const typeOptions = {
        0: "",
        1: "warning",
        2: "success",
        3: "success",
        4: "danger",
        5: "danger"
      };
      return typeOptions[level];
    },
    handleSelectStackLevelCommand(command) {
      const commandArr = command.split("-");
      const index = commandArr[0];
      const level = Number(commandArr[1]);
      this.$set(this.stacks[index], "level", level);
    }
  }
};
</script>

<style type="text/css" lang="less" scoped>
.tag-icon {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  margin-right: 5px;
  vertical-align: middle;
  background-color: #f5f5f5;
}
.tag-text {
  vertical-align: middle;
}
.el-tag {
  margin-right: 10px;
  margin-bottom: 10px;
}
.button-new-tag {
  height: 32px;
  line-height: 32px;
  padding-top: 0;
  padding-bottom: 0;
  font-size: 12px;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
